import { ShowDocumentPersonalizadoModalForm } from "./ShowDocumentPersonalizadoModalForm"


const ShowDocumentPersonalizadoModalFormWrapper = () => {
    return (<ShowDocumentPersonalizadoModalForm />)
}

export {ShowDocumentPersonalizadoModalFormWrapper}